import type { PropsWithChildren } from "react";
import { ManagementSectionPreloader } from "../Preloaders/ManagementSectionPreloader";

export const WrappedWithManagementPreloader = ({ isLoading, children }: PropsWithChildren<{ isLoading: boolean }>) => {
    return isLoading ? <ManagementSectionPreloader /> : <>{children}</>;
}
